import type { EsInsuranceConfig } from "@/pages/es/EsInsurancePage";

const REVIEW = {
  reviewedBy: "Daniel Pietras, MD",
  lastUpdated: "October 19, 2026",
};

/**
 * Top insurer pages translated to Spanish. Each slug mirrors an existing
 * English insurer route so hreflang alternates pair correctly.
 */
export const esInsuranceConfigs: EsInsuranceConfig[] = [
  {
    ...REVIEW,
    providerName: "Aetna",
    shortName: "Aetna",
    slug: "aetna-insurance",
    seoTitle: "Cobertura de Aetna para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro Aetna? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de Aetna en Coral Springs, FL.",
    planType: "proveedor nacional de seguro médico (filial de CVS Health)",
    planRegion: "todo el país",
    memberTerm: "miembros",
    planSpecificIntro:
      "Aetna es uno de los mayores proveedores nacionales de seguro médico, con una amplia gama de planes comerciales, patrocinados por el empleador, Medicare Advantage y Medicaid. Los planes de Aetna suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y otros tratamientos de neuromodulación cuando se cumplen los criterios de necesidad médica. Como Aetna ofrece muchos tipos de plan — incluidas redes HMO, PPO, EPO y POS — la cobertura de TMS, los protocolos acelerados y otros tratamientos avanzados para la depresión varía significativamente según su plan y red específicos.",
    officialResourceUrl: "https://www.aetna.com/",
    officialResourceLabel: "Sitio web oficial de Aetna",
  },
  {
    ...REVIEW,
    providerName: "Cigna",
    shortName: "Cigna",
    slug: "cigna-insurance",
    seoTitle: "Cobertura de Cigna para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro Cigna? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de Cigna en Coral Springs, FL.",
    planType: "proveedor mundial de seguro médico",
    planRegion: "todo el país",
    memberTerm: "miembros",
    planSpecificIntro:
      "Cigna es un proveedor mundial de seguro médico que ofrece planes comerciales, patrocinados por el empleador y de Medicare. Los planes de Cigna suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS, los protocolos acelerados y otros tratamientos avanzados varía según su plan y red específicos.",
    officialResourceUrl: "https://www.cigna.com/",
    officialResourceLabel: "Sitio web oficial de Cigna",
  },
  {
    ...REVIEW,
    providerName: "UnitedHealthcare",
    shortName: "UnitedHealthcare",
    slug: "unitedhealthcare-insurance",
    seoTitle: "Cobertura de UnitedHealthcare para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro UnitedHealthcare? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de UnitedHealthcare en Coral Springs, FL.",
    planType: "proveedor nacional de seguro médico",
    planRegion: "todo el país",
    memberTerm: "miembros",
    planSpecificIntro:
      "UnitedHealthcare es uno de los mayores proveedores nacionales de seguro médico, con planes comerciales, patrocinados por el empleador, Medicare Advantage y Medicaid. Los planes de UnitedHealthcare suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos.",
    officialResourceUrl: "https://www.uhc.com/",
    officialResourceLabel: "Sitio web oficial de UnitedHealthcare",
  },
  {
    ...REVIEW,
    providerName: "Florida Blue",
    shortName: "Florida Blue",
    slug: "florida-blue-insurance",
    seoTitle: "Cobertura de Florida Blue para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro Florida Blue? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de Florida Blue en Coral Springs, FL.",
    planType: "licenciatario de Blue Cross Blue Shield en Florida",
    planRegion: "Florida",
    memberTerm: "miembros",
    planSpecificIntro:
      "Florida Blue es el licenciatario de Blue Cross Blue Shield en Florida y ofrece planes individuales, familiares, patrocinados por el empleador, Medicare Advantage y Medicaid. Los planes de Florida Blue suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos.",
    officialResourceUrl: "https://www.floridablue.com/",
    officialResourceLabel: "Sitio web oficial de Florida Blue",
  },
  {
    ...REVIEW,
    providerName: "Anthem Blue Cross",
    shortName: "Anthem",
    slug: "anthem-blue-cross-insurance",
    seoTitle: "Cobertura de Anthem Blue Cross para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro Anthem Blue Cross? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de Anthem en Coral Springs, FL.",
    planType: "proveedor nacional de seguro médico",
    planRegion: "varios estados",
    memberTerm: "miembros",
    planSpecificIntro:
      "Anthem Blue Cross es un proveedor de seguro médico que ofrece planes comerciales, patrocinados por el empleador, Medicare Advantage y Medicaid en varios estados. Los planes de Anthem suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos.",
    officialResourceUrl: "https://www.anthem.com/",
    officialResourceLabel: "Sitio web oficial de Anthem",
  },
  {
    ...REVIEW,
    providerName: "Blue Cross Blue Shield of Illinois",
    shortName: "BCBSIL",
    slug: "bcbsil-insurance",
    seoTitle: "Cobertura de BCBSIL para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro BCBSIL? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de BCBSIL en Coral Springs, FL.",
    planType: "licenciatario de Blue Cross Blue Shield en Illinois",
    planRegion: "Illinois",
    memberTerm: "miembros",
    planSpecificIntro:
      "Blue Cross Blue Shield of Illinois (BCBSIL) es el licenciatario de Blue Cross Blue Shield en Illinois y ofrece planes individuales, familiares, patrocinados por el empleador, Medicare Advantage y Medicaid. Los planes de BCBSIL suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos.",
    officialResourceUrl: "https://www.bcbsil.com/",
    officialResourceLabel: "Sitio web oficial de BCBSIL",
  },
  {
    ...REVIEW,
    providerName: "Aetna (Marketplace)",
    shortName: "Aetna",
    slug: "aetna-marketplace-insurance",
    seoTitle: "Cobertura de Aetna Marketplace para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene un plan de Aetna del Marketplace? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan del Marketplace en Coral Springs, FL.",
    planType: "plan del Marketplace (ACA)",
    planRegion: "todo el país",
    memberTerm: "miembros",
    planSpecificIntro:
      "Los planes de Aetna del Marketplace (ACA) ofrecen cobertura de salud individual y familiar. Estos planes suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos del Marketplace.",
    officialResourceUrl: "https://www.aetna.com/",
    officialResourceLabel: "Sitio web oficial de Aetna",
  },
  {
    ...REVIEW,
    providerName: "Cigna (Marketplace)",
    shortName: "Cigna",
    slug: "cigna-marketplace-insurance",
    seoTitle: "Cobertura de Cigna Marketplace para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene un plan de Cigna del Marketplace? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan del Marketplace en Coral Springs, FL.",
    planType: "plan del Marketplace (ACA)",
    planRegion: "todo el país",
    memberTerm: "miembros",
    planSpecificIntro:
      "Los planes de Cigna del Marketplace (ACA) ofrecen cobertura de salud individual y familiar. Estos planes suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos del Marketplace.",
    officialResourceUrl: "https://www.cigna.com/",
    officialResourceLabel: "Sitio web oficial de Cigna",
  },
  {
    ...REVIEW,
    providerName: "UnitedHealthcare (Marketplace)",
    shortName: "UnitedHealthcare",
    slug: "uhc-marketplace-insurance",
    seoTitle: "Cobertura de UHC Marketplace para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene un plan de UnitedHealthcare del Marketplace? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan del Marketplace en Coral Springs, FL.",
    planType: "plan del Marketplace (ACA)",
    planRegion: "todo el país",
    memberTerm: "miembros",
    planSpecificIntro:
      "Los planes de UnitedHealthcare del Marketplace (ACA) ofrecen cobertura de salud individual y familiar. Estos planes suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos del Marketplace.",
    officialResourceUrl: "https://www.uhc.com/",
    officialResourceLabel: "Sitio web oficial de UnitedHealthcare",
  },
  {
    ...REVIEW,
    providerName: "Florida Blue (Marketplace)",
    shortName: "Florida Blue",
    slug: "florida-blue-marketplace-insurance",
    seoTitle:
      "Cobertura de Florida Blue Marketplace para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene un plan de Florida Blue del Marketplace? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan del Marketplace en Coral Springs, FL.",
    planType: "plan del Marketplace (ACA)",
    planRegion: "Florida",
    memberTerm: "miembros",
    planSpecificIntro:
      "Los planes de Florida Blue del Marketplace (ACA) ofrecen cobertura de salud individual y familiar en Florida. Estos planes suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos del Marketplace.",
    officialResourceUrl: "https://www.floridablue.com/",
    officialResourceLabel: "Sitio web oficial de Florida Blue",
  },
  {
    ...REVIEW,
    providerName: "Ambetter",
    shortName: "Ambetter",
    slug: "ambetter-insurance",
    seoTitle: "Cobertura de Ambetter para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro Ambetter? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de Ambetter en Coral Springs, FL.",
    planType: "proveedor de planes del Marketplace (ACA)",
    planRegion: "varios estados",
    memberTerm: "miembros",
    planSpecificIntro:
      "Ambetter ofrece planes de salud individuales y familiares del Marketplace (ACA) en varios estados. Los planes de Ambetter suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos.",
    officialResourceUrl: "https://ambetterhealth.com/",
    officialResourceLabel: "Sitio web oficial de Ambetter",
  },
  {
    ...REVIEW,
    providerName: "Oscar",
    shortName: "Oscar",
    slug: "oscar-insurance",
    seoTitle: "Cobertura de Oscar para TMS | Neuro Wellness TMS",
    seoDescription:
      "¿Tiene seguro Oscar? Conozca la terapia TMS, SAINT TMS y las opciones de tratamiento para la depresión que pueden estar disponibles a través de su plan de Oscar en Coral Springs, FL.",
    planType: "proveedor de seguro médico centrado en tecnología",
    planRegion: "varios estados",
    memberTerm: "miembros",
    planSpecificIntro:
      "Oscar es un proveedor de seguro médico que ofrece planes individuales, familiares y del Marketplace en varios estados. Los planes de Oscar suelen incluir beneficios de salud conductual que pueden cubrir la terapia TMS y tratamientos de neuromodulación relacionados cuando se cumplen los criterios de necesidad médica. La cobertura de TMS y protocolos acelerados varía según su plan y red específicos.",
    officialResourceUrl: "https://www.hioscar.com/",
    officialResourceLabel: "Sitio web oficial de Oscar",
  },
];

export function findEsInsuranceBySlug(slug: string) {
  return esInsuranceConfigs.find((c) => c.slug === slug);
}
